import routes from "@/routes";
import { lazy } from "react";

const AbmBeta = lazy(() => import("@/modules/Report/AbmBeta"));

const AbmBetaRoutes = {
  element: <AbmBeta />,
  path: routes.REPORTS.ABM_BETA.INDEX,
};

export default AbmBetaRoutes;
